<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <h2 fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
      <img class="clickable" [routerLink]="['../']" src="/assets/iconography/arrow-left-rose.svg" />
      <span fxFlex>Missing an integration?</span>
    </h2>

    <div fxLayout fxLayout.lt-md="column" fxLayoutGap="40px" fxLayoutAlign="start center">
      <div fxFlex>
        <h3>Vote for an integration</h3>
        <p>This is the list of planned integrations. Add your vote to register your interest and receive updates.</p>
      </div>
      <button type="submit" mat-flat-button class="button__secondary" (click)="suggestIdea()">Suggest an idea</button>
    </div>

    <section class="integrations-list">
      <mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>

      <article class="integration" *ngFor="let integration of integrations">
        <img
          class="icon"
          *ngIf="integration.image"
          [attr.src]="'/assets/images/apps/integrations/' + integration.image + '.svg'" />
        <header>
          <h1>
            {{ integration.name }}
            <span class="tag" *ngFor="let cat of integration.categories">{{ cat }}</span>
          </h1>
          <em>{{ integration.description }}</em>
        </header>
        <button
          class="upvote"
          (click)="upvote(integration)"
          [ngClass]="{ voted: integration.has_voted }"
          [attr.title]="'vote for ' + integration.name">
          <svg>
            <use href="/assets/images/apps/integrations.svg#arrow"></use>
          </svg>
          <span>{{ integration.votes }}</span>
        </button>
      </article>
    </section>
  </main>
</div>
